module.exports = __webpack_public_path__ + "static/media/logo-moc.d0aaed61.png";